export default __webpack_public_path__ + "static/media/retro4.827056a3.jpg";